const BorrowersSkeleton = () => {
  return (
    <div className="w-full pr-[40px] pl-[10px] animate-pulse">
      {/* Header */}
      <div className="flex items-center my-[10px] justify-between">
        <div className="h-[28px] bg-gray-300 rounded w-[150px]" />
        <div className="h-[40px] bg-gray-300 rounded-[30px] w-[200px]" />
      </div>

      {/* Cards */}
      <div className="flex items-center gap-[20px] mb-6">
        {[1, 2].map((_, i) => (
          <div
            key={i}
            className="h-[100px] flex-1 bg-gray-200 rounded-[20px] p-4"
          />
        ))}
      </div>

      {/* Actions */}
      <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px]">
        <div className="h-[40px] w-[117px] bg-gray-300 rounded-[10px]" />
        <div className="h-[40px] w-[117px] bg-gray-300 rounded-[10px]" />
        <div className="h-[40px] w-[127px] bg-gray-300 rounded-[10px]" />
        <div className="h-[40px] w-[50%] bg-gray-300 rounded-md" />
        <div className="h-[20px] w-[80px] bg-gray-300 rounded" />
        <div className="h-[40px] w-[120px] bg-gray-300 rounded-[30px]" />
      </div>

      {/* Table Header */}
      <div className="h-[44px] px-[10px] w-full bg-[#F3F3F3] mb-[10px] flex items-center">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="w-[14%]">
            <div className="h-[20px] bg-gray-300 rounded w-[100%]" />
          </div>
        ))}
      </div>

      {/* Borrower Rows */}
      {[...Array(10)].map((_, i) => (
        <div
          key={i}
          className="h-[35px] px-[10px] w-full bg-white mb-[10px] flex items-center"
        >
          {[...Array(8)].map((_, j) => (
            <div key={j} className="w-[14%]">
              <div className="h-[15px] bg-gray-200 rounded w-[100%]" />
            </div>
          ))}
        </div>
      ))}

      {/* Pagination */}
      <div className="h-[50px] mb-[20px] flex items-center justify-between">
        <div className="flex items-center gap-[10px]">
          <div className="h-[20px] w-[80px] bg-gray-300 rounded" />
          <div className="h-[20px] w-[80px] bg-gray-300 rounded" />
          <div className="h-[20px] w-[40px] bg-gray-300 rounded" />
          <div className="h-[35px] w-[100px] bg-gray-300 rounded" />
        </div>
        <div className="h-[30px] w-[200px] bg-gray-300 rounded" />
      </div>
    </div>
  );
};

export default BorrowersSkeleton;
